module.exports = __webpack_public_path__ + "img/IC_Empleado.3c6d3cd3.png";